import * as core from '../../../../../../../core'

import { query } from './sponsors-table-updated-org-structure.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.sponsors-table',
    description:
      'Displays a list of sponsors in a table widget without Award Funding, IDC, or related metrics',
    name: 'RP Explore - Sponsors Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
